<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/stores/app'
import SvgIcon from '../SvgIcon.vue'
import { ESprites, ESpritesFlags } from '@/shared/enum/sprites.enum'
import { ECountry } from '@/shared/enum/country.enum'

const appStore = useAppStore()

const countryFlagLogos = {
  [ECountry.GT]: ESpritesFlags.GUATEMALA,
  [ECountry.CR]: ESpritesFlags.COSTA_RICA,
  [ECountry.SV]: ESpritesFlags.EL_SALVADOR,
  [ECountry.HN]: ESpritesFlags.HONDURAS,
  [ECountry.NI]: ESpritesFlags.NICARAGUA,
  usa: ESpritesFlags.USA
}
</script>

<template>
  <span class="flex justify-center gap-4">
    <svg-icon
      :file="ESprites.FLAGS"
      :name="countryFlagLogos[appStore.country]"
      :width="32"
      :height="32"
      class="rounded-full"
    />
    <svg-icon
      :file="ESprites.FLAGS"
      :name="countryFlagLogos.usa"
      :width="32"
      :height="32"
      class="rounded-full"
    />
  </span>
</template>

<style scoped></style>
